var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2512_8812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9531 0.75C5.36203 0.75 0 5.481 0 11.2969C0 13.7537 0.972281 16.1343 2.74177 18.0212C3.09197 19.4652 2.66691 20.995 1.61222 22.0497C1.17122 22.4908 1.48308 23.25 2.10938 23.25C4.113 23.25 6.04453 22.4652 7.47961 21.0809C8.89959 21.5876 10.402 21.8438 11.9531 21.8438C18.5442 21.8438 24 17.1127 24 11.2969C24 5.481 18.5442 0.75 11.9531 0.75ZM6.42188 13.4062C5.25872 13.4062 4.3125 12.46 4.3125 11.2969C4.3125 10.1337 5.25872 9.1875 6.42188 9.1875C7.58503 9.1875 8.53125 10.1337 8.53125 11.2969C8.53125 12.46 7.58503 13.4062 6.42188 13.4062ZM12.0469 13.4062C10.8837 13.4062 9.9375 12.46 9.9375 11.2969C9.9375 10.1337 10.8837 9.1875 12.0469 9.1875C13.21 9.1875 14.1562 10.1337 14.1562 11.2969C14.1562 12.46 13.21 13.4062 12.0469 13.4062ZM17.6719 13.4062C16.5087 13.4062 15.5625 12.46 15.5625 11.2969C15.5625 10.1337 16.5087 9.1875 17.6719 9.1875C18.835 9.1875 19.7812 10.1337 19.7812 11.2969C19.7812 12.46 18.835 13.4062 17.6719 13.4062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2512_8812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f1b32136cc771d7a8ef33aff4c65f7a0.svg";
export { ForwardRef as ReactComponent };